import { css, CSSResult } from 'lit'

export const style: CSSResult = css`
  :host {
    display: contents;
    position: relative;
  }

  .cse-popup {
    position: absolute;
    isolation: isolate;

    max-width: var(--cse-popup-auto-size-available-width, auto);
    max-height: var(--cse-popup-auto-size-available-height, auto);

    z-index: var(--cse-popup-z-index, 900);
  }

  .cse-popup:not(.active) {
    display: none;
  }
`
